import Sprite from "./Sprite";
import { BODY_SKINS, DIRECTION_LEFT } from "../../helpers/consts";
import { TILES } from "../../helpers/tiles";
import styles from "./Hero.module.css";

const EDIT_MODE = "EDIT_MODE";
const HERO_DEATH = "HERO_DEATH";
const HERO_RUN_1 = "HERO_RUN_1";
const HERO_RUN_2 = "HERO_RUN_2";

const heroSkinMap = {
  [BODY_SKINS.NORMAL]: [TILES.HERO_LEFT, TILES.HERO_RIGHT],
  [BODY_SKINS.WATER]: [TILES.HERO_WATER_LEFT, TILES.HERO_WATER_RIGHT],
  [BODY_SKINS.ICE]: [TILES.HERO_ICE_LEFT, TILES.HERO_ICE_RIGHT],
  [BODY_SKINS.CONVEYOR]: [TILES.HERO_CONVEYOR_LEFT, TILES.HERO_CONVEYOR_RIGHT],
  [BODY_SKINS.FIRE]: [TILES.HERO_FIRE_LEFT, TILES.HERO_FIRE_RIGHT],
  [BODY_SKINS.TELEPORT]: [TILES.HERO_TELEPORT_LEFT, TILES.HERO_TELEPORT_RIGHT],
  [BODY_SKINS.SCARED]: [TILES.HERO_DEATH_LEFT, TILES.HERO_DEATH_RIGHT],
  [EDIT_MODE]: [TILES.HERO_EDITING_LEFT, TILES.HERO_EDITING_RIGHT],
  [HERO_DEATH]: [TILES.HERO_DEATH_LEFT, TILES.HERO_DEATH_RIGHT],
  [HERO_RUN_1]: [TILES.HERO_RUN_1_LEFT, TILES.HERO_RUN_1_RIGHT],
  [HERO_RUN_2]: [TILES.HERO_RUN_2_LEFT, TILES.HERO_RUN_2_RIGHT],
};

export default function Hero({
  movingPixelsRemaining,
  isEditMode,
  heroDeath,
  direction,
  skin,
  walkFrame,
}) {
  const getFrame = () => {
    const index = direction === DIRECTION_LEFT ? 0 : 1;
    if (isEditMode) {
      return heroSkinMap[EDIT_MODE][index];
    }
    if (heroDeath) {
      return heroSkinMap[HERO_DEATH][index];
    }
    if (movingPixelsRemaining > 0 && skin === BODY_SKINS.NORMAL) {
      const walkKey = walkFrame === 1 ? HERO_RUN_1 : HERO_RUN_2;
      return heroSkinMap[walkKey][index];
    }
    return heroSkinMap[skin][index];
  };

  const getYTranslate = () => {
    // Elevate a bit when hopping
    const isValidSkin = skin === BODY_SKINS.NORMAL;
    if (movingPixelsRemaining > 0 && isValidSkin) {
      if (movingPixelsRemaining < 2 || movingPixelsRemaining > 16 - 2) {
        return -1;
      }
      return -2;
    }
    return 0;
  };

  return (
    <div className={styles.hero}>
      <div
        style={{
          opacity: skin === BODY_SKINS.WATER ? 0 : 1,
        }}
      >
        <Sprite frameCoord={TILES.SHADOW} />
      </div>
      <div
        className={styles.heroBody}
        style={{
          transform: `translateY(${getYTranslate()}px)`,
        }}
      >
        <Sprite frameCoord={getFrame()} size={32} />
      </div>
    </div>
  );
}
